import bing_Aerial from './img/Bing_Aerial.png';
import cartoDB_DarkMatter from './img/CartoDB_DarkMatter.png';
import cartoDB_VoyagerNoLabels from './img/CartoDB_VoyagerNoLabels.png';
import esri_WorldGrayCanvas from './img/Esri_WorldGrayCanvas.png';
import esri_WorldImagery from './img/Esri_WorldImagery.png';
import esri_WorldTopoMap from './img/Esri_WorldTopoMap.png';
import noPreview from './img/noPreview.png';
import openStreetMap_Mapnik from './img/OpenStreetMap_Mapnik.png';
import wikimedia from './img/wikimedia.png';

export default {
	bing_Aerial,
	cartoDB_DarkMatter,
	cartoDB_VoyagerNoLabels,
	esri_WorldGrayCanvas,
	esri_WorldImagery,
	esri_WorldTopoMap,
	noPreview,
	openStreetMap_Mapnik,
	wikimedia,
};
